import { handleActions } from 'redux-actions';
import { push } from "react-router-redux";
import { initialize as initializeForm } from 'redux-form';
import { NotificationManager } from "react-notifications";
import { api } from "api";

const LISTADO_ELZM = 'LISTADO_ELZM';
const LOADER = 'LOADER';
const MODULO = 'MODULO';

const setLoader = loader => ({
    type: LOADER,
    loader,
});

export const listar = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    let params = { id };
    dispatch(setLoader(true));
    api.get('/rs_elzm', params).then((response)=>{
        dispatch({ type: LISTADO_ELZM, data: response });
    }).catch((error)=>{
        NotificationManager.error(
            'Ocurrió un error al listar ELZM',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const registroELZM = () => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const data = getStore().form.FormELZM.values;
    let id_empresa = id_emp[5]

    const formData = {
        codigo_letra: data.codigo_letra,
        familia: data.familia_nuclear,
        fabricante: data.fabricante,
        marca: data.marca,
        empresa: id_empresa
    }
    dispatch(setLoader(true));
    api.post('/rs_elzm/', formData).then(() => {
        NotificationManager.success(
        'Código de unificación creado',
        'Exito',
        3000
    );
    let ruta = `/registro_sanitario/${id_emp[5]}/elzm`
    dispatch(push(ruta));
    }).catch((error) => {
    NotificationManager.error(
        error.msj,
        'Error',
        2000
    );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const modificarELZM = () => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const datos = getStore().form.FormELZM.values;
    const id = datos.id;
    const formData = {
        id: id,
        codigo_letra: datos.codigo_letra,
        familia: datos.familia_nuclear,
        fabricante: datos.fabricante,
        marca: datos.marca,
    }
    dispatch(setLoader(true));
    api.put(`/rs_elzm/${id}/`, formData).then(() => {
        NotificationManager.success(
            'Código de unificación modificado correctamente',
            'Exito',
            3000
        );
        let ruta = `/registro_sanitario/${id_emp[5]}/elzm`
        dispatch(push(ruta));
    }).catch((error) => {
        NotificationManager.error(
            error.msj,
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const leer = (id) => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`/rs_elzm/${id}`).then((response) => {
        dispatch(initializeForm('FormELZM', response ));
    }).catch((error)=>{
        
        NotificationManager.error(
            'Ocurrió un error al consultar ELZM',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });

}

export const getModulo = (id, modulo) => (dispatch) => {
    const params = {id, modulo}
    dispatch(setLoader(true));
    api.get('/modulos/modulo/', params).then((response)=>{
        dispatch({ type: MODULO, modulo: response.modulos });
    }).catch(() => {
        NotificationManager.error(
            'Ocurrió un error en buscar modulo',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

export const actions = {
    listar,
    registroELZM,
    modificarELZM,
    leer,
    getModulo
};

export const reducers = {
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [LISTADO_ELZM]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [MODULO]: (state, { modulo }) => {
        return {
            ...state,
            modulo,
        };
    },
};

export const initialState = {
    loader: false,
    modulo: [],
    data: []
};

export default handleActions(reducers, initialState)
 